import React from 'react';
import { Box } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';

/** Estimated total (base pay + 100-visit CPA). The parts sit beside it when both exist. */
export function CreatorPayoutAmount({
    total,
    base,
    additional,
    fallback,
}: {
    total?: string | null;
    base?: string | null;
    additional?: string | null;
    fallback?: React.ReactNode;
}) {
    const figure = total || additional || base || fallback;
    if (!figure) return null;
    const parts = base && additional ? `${base} base + ${additional}` : null;
    const markEstimated = Boolean(total || additional);

    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0.55, flexWrap: 'wrap' }}>
            <span>{figure}</span>
            {markEstimated ? (
                <Box
                    component="span"
                    sx={{
                        fontSize: '0.48em',
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        letterSpacing: '0.01em',
                        lineHeight: 1.15,
                        whiteSpace: 'nowrap',
                        opacity: 0.9,
                    }}>
                    {parts ? `est. ${parts}` : 'est.'}
                </Box>
            ) : null}
        </Box>
    );
}
